import React, { useEffect, useState } from 'react';
import { Calendar } from 'primereact/calendar';
import PhoneInput from 'react-phone-input-2';
import { RadioButton } from 'primereact/radiobutton';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import Wrapper from '../layouts/Wrapper';
import calendarIcon from '../assets/icons/calendar.svg';
import BasketModalItem from '../components/BasketModalItem';
import Spinner from '../components/Spinner';
import { removeFromLocalBasket, removeFromUserBasket } from '../store/actions/basketActions';
import { checkOutRequest } from '../store/actions/checkOutAction';
import DropDownIconTemplate from '../components/DropDownIconTemplate';
import { clearBasket } from '../store/actions/user';
import Api from '../api';
import PageNotFound from './PageNotFound';

const armenianHolidays = [
  new Date(new Date().getFullYear(), 0, 1),
  new Date(new Date().getFullYear(), 0, 6),
  new Date(new Date().getFullYear(), 0, 28),
  new Date(new Date().getFullYear(), 2, 8),
  new Date(new Date().getFullYear(), 4, 1),
  new Date(new Date().getFullYear(), 4, 9),
  new Date(new Date().getFullYear(), 4, 28),
  new Date(new Date().getFullYear(), 6, 5),
  new Date(new Date().getFullYear(), 8, 21),
  new Date(new Date().getFullYear(), 11, 31),
];
const minTime = new Date();
minTime.setHours(9, 0, 0);
const maxTime = new Date();
maxTime.setHours(18, 0, 0);

function CheckOut({ branches = [] }) {
  const [phoneNumberLength, setPhoneNumberLength] = useState(11);
  const [invalidPhoneNumber, setInvalidPhoneNumber] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [promoCode, setPromoCode] = useState(null);
  const [isValidCode, setSetIsValidCode] = useState(null);
  const { user } = useSelector((state) => state.users);
  const [payment, setPayment] = useState('cash');
  const lang = Cookies.get('i18next') || 'en';
  const [selectedBranch, setSelectedBranch] = useState(null);
  const { translations, loading } = useSelector((state) => state.translation);
  const { cart } = useSelector((state) => state.users);
  const { isAuth, token } = useSelector((state) => state.users);
  const [name, setName] = useState(user.first_name || '');
  const [lastName, setLastName] = useState(user.last_name || '');
  const [email, setEmail] = useState(user.email || '');
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [phone, setPhone] = useState(user.phone || '');
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [phoneError, setPhoneError] = useState('');
  const [nameError, setNameError] = useState('');
  const [lastNameError, setLastNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [dateError, setDateError] = useState('');
  const [timeError, setTimeError] = useState('');
  const [branchError, setBranchError] = useState('');
  const handleChange = (paymentCb) => {
    setPayment(paymentCb);
  };
  const handleDeleteFromBasket = async (id) => {
    if (!isAuth) {
      const basket = JSON.parse(localStorage.getItem('basket')) || [];
      localStorage.setItem('basket', JSON.stringify(basket.filter((item) => item.id !== id)));
      dispatch(removeFromLocalBasket(id));
      toast(translations.deleted[lang]);
    } else {
      const { payload } = await dispatch(removeFromUserBasket({ id, token }));
      if (payload.message === 'Cart deleted') {
        toast(translations.deleted[lang]);
      }
    }
  };
  useEffect(() => {
    setPhoneError('');
  }, [phone]);

  // const handleChangeBonuses = (e) => {
  //   const inputValue = e.target.value;
  //   if (/^\d*\.?\d*$/.test(inputValue)) {
  //     const numericValue = parseFloat(inputValue);
  //     if (numericValue <= (cart.reduce((acc, item) => acc + +item.price, 0) / price)
  //         || Number.isNaN(numericValue)) {
  //       setSelectedBonuses(Math.min(inputValue, points));
  //     } else {
  //       setSelectedBonuses(Math.min((cart.reduce((acc, item) => acc + +item.price, 0)
  //           / price).toFixed(2), points));
  //     }
  //   }
  // };
  // utils/date.js

  const formatDate = (input) => {
    if (!input) return '';
    const d = new Date(input);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`; // YYYY-MM-DD
  };

  const formatTime = (input) => {
    if (!input) return '';
    const d = new Date(input);

    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');

    return `${hours}:${minutes}`; // HH:mm
  };
  const handleCheckout = async () => {
    setLoadingBtn(true);
    const dateToSend = formatDate(date);
    const timeToSend = formatTime(time);
    const paymentType = payment === 'cash' ? 'cash' : 'vPos';
    const data = {
      branch: selectedBranch ? selectedBranch.address[lang] : '',
      branch_id: selectedBranch ? selectedBranch.id : '',
      name,
      surname: lastName,
      email,
      date: dateToSend,
      time: timeToSend,
      phone,
      promo_code: isValidCode ? promoCode : null,
      // eslint-disable-next-line camelcase
      payment_type: paymentType,
      lang,
    };
    const { payload } = await dispatch(checkOutRequest(data));
    setLoadingBtn(false);
    if (payload.status === 'error') {
      if (payload?.messages?.phone) {
        setPhoneError(payload?.messages?.phone);
      }
      if (payload?.messages?.name) {
        setNameError(payload?.messages?.name);
      }
      if (payload?.messages?.surname) {
        setLastNameError(payload?.messages?.surname);
      }
      if (payload?.messages?.date) {
        setDateError(payload?.messages?.date);
      }
      if (payload?.messages?.time) {
        setTimeError(payload?.messages?.time);
      }
      if (payload?.messages?.email) {
        setEmailError(payload?.messages?.email);
      }
      if (payload?.messages?.branch) {
        setBranchError(payload?.messages?.branch);
      }
    }
    if (phone?.length !== phoneNumberLength) {
      setInvalidPhoneNumber(true);
      return;
    }
    if (payload.message === 'Register successfully') {
      toast(translations.register_success[lang]);
      setTimeout(() => {
        navigate(`/${lang}`);
        dispatch(clearBasket());
      }, 1500);
    } else if (payload.redirectURL) {
      window.location.replace(payload.redirectURL);
    }
  };
  const handleApplyCode = async (e) => {
    try {
      e.preventDefault();
      setSetIsValidCode(false);
      const { data } = await Api.checkPromoCode(promoCode);
      if (data.success) {
        setSetIsValidCode(1);
      } else {
        setSetIsValidCode(2);
      }
    } catch (error) {
      console.error(error);
    }
  };
  if (cart.length === 0) {
    return (<PageNotFound />);
  }
  return (
    <Wrapper>
      {!loading ? (
        <div className="container small">
          <div className="book">
            <div className="person-info">
              <div className="person-info-item">
                <h2 className="person-info-title">{translations.personal_information[lang]}</h2>
                <form action="#" className="modal-form">
                  <div className="middle-block">
                    <div className="modal-input-container">
                      <div className="modal-input-block">
                        <label htmlFor="firstName" className="modal-input-block-label">
                          {translations.first_name_label[lang]}
                          *
                        </label>
                        <input
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                            setNameError('');
                          }}
                          placeholder={translations.first_name_placeholder[lang]}
                          type="text"
                          id="firstName"
                          className="modal-input-block-input checkout"
                        />
                        {nameError && <p className="authError">{nameError}</p>}
                      </div>
                    </div>
                    <div className="modal-input-container">
                      <div className="modal-input-block">
                        <label htmlFor="lastName" className="modal-input-block-label">
                          {translations.last_name_label[lang]}
                          *
                        </label>
                        <input
                          value={lastName}
                          onChange={(e) => {
                            setLastName(e.target.value);
                            setLastNameError('');
                          }}
                          placeholder={translations.last_name_placeholder[lang]}
                          type="text"
                          id="lastName"
                          className="modal-input-block-input checkout"
                        />
                        {lastNameError && <p className="authError">{lastNameError}</p>}
                      </div>
                    </div>
                  </div>
                  <div className="middle-block">
                    <div className="modal-input-container">
                      <div className="modal-input-block">
                        <label htmlFor="email" className="modal-input-block-label">
                          {translations.email_label[lang]}
                          *
                        </label>
                        <input
                          disabled
                          readOnly
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setEmailError('');
                          }}
                          placeholder={translations.email_placeholder[lang]}
                          type="text"
                          id="email"
                          className="modal-input-block-input checkout"
                        />
                        {emailError && <p className="authError">{emailError}</p>}
                      </div>
                    </div>
                    <div className="modal-input-container">
                      <div className="modal-input-block">
                        <label htmlFor="phone" className="modal-input-block-label">
                          {translations.phone[lang]}
                          *
                        </label>
                        <PhoneInput
                          id="phone"
                          country="am"
                          value={phone}
                          onChange={(e, info) => {
                            setInvalidPhoneNumber(false);
                            const expectedLength = (info?.format.match(/\./g) || [])
                              .length;
                            setPhoneNumberLength(expectedLength);
                            setPhone(e);
                          }}
                          containerClass="phone-input-container"
                          inputClass="phone-input"
                          buttonClass="phone-input-button"
                          dropdownClass="phone-input-dropdown"
                        />
                        {invalidPhoneNumber && !phoneError && (
                          <p className="authError">{translations.phone_error[lang]}</p>
                        )}
                        {phoneError && <p className="authError">{phoneError}</p>}
                      </div>
                    </div>
                  </div>
                  <div className="middle-block">
                    <div className="modal-input-container">
                      <div className="modal-input-block">
                        <label htmlFor="date" className="modal-input-block-label">
                          {translations.visit_date[lang]}
                          {' '}
                          *
                        </label>
                        <Calendar
                          disabledDates={armenianHolidays}
                          disabledDays={[0, 6]}
                          showIcon
                          icon={() => (
                            <img
                              src={calendarIcon}
                              alt="calendar"
                              className="calendar-icon"
                            />
                          )}
                          minDate={new Date()}
                          placeholder={translations.coose_placeholder[lang]}
                          value={date}
                          onChange={(e) => {
                            setDate(e.value);
                            setDateError('');
                          }}
                          className="calendar"
                          inputClassName="calendar-input"
                          panelClassName="calendar-panel"
                          todayButtonClassName="calendar-today-button"
                          clearButtonClassName="calendar-clear-button"
                          id="date"
                          selectionMode="single"
                        />
                        {dateError && <p className="authError">{dateError}</p>}
                      </div>
                    </div>
                    <div className="modal-input-container">
                      <div className="modal-input-block">
                        <label htmlFor="time" className="modal-input-block-label">
                          {translations.visit_time_label[lang]}
                          *
                        </label>
                        <Calendar
                          minDate={minTime}
                          maxDate={maxTime}
                          inputMode="text"
                          type="text"
                          mask="99:99"
                          timeOnly
                          placeholder={translations.coose_placeholder[lang]}
                          value={time}
                          onChange={(e) => {
                            setTime(e.value);
                            setTimeError('');
                          }}
                          className="calendar"
                          inputClassName="calendar-input"
                          panelClassName="calendar-panel"
                          todayButtonClassName="calendar-today-button"
                          clearButtonClassName="calendar-clear-button"
                          id="time"
                          hourFormat="24"
                          selectionMode="single"
                        />
                        {timeError && <p className="authError">{timeError}</p>}
                      </div>
                    </div>
                  </div>
                  <div className="mmiddle-block">
                    <div className="modal-input-container">
                      <div className="modal-input-block">
                        <label htmlFor="position" className="modal-input-block-label">
                          {translations.branch[lang]}
                          {' '}
                          *
                        </label>
                        <Dropdown
                          panelClassName="locations-dropdown-panel modal"
                          itemTemplate={(e) => (
                            <div className="modal-input-dropdown-item">
                              <p className="modal-input-dropdown-item-text">
                                {e.address[lang]}
                              </p>
                            </div>
                          )}
                          placeholder={translations.branch_placeholder[lang]}
                          dropdownIcon={() => <DropDownIconTemplate collapse={false} black />}
                          collapseIcon={() => <DropDownIconTemplate collapse black />}
                          className="modal-popup-select"
                          valueTemplate={(e) => (
                            selectedBranch
                              ? <p className="modal-popup-value">{e.address[lang]}</p>
                              : <p className="modal-input-block-label">{translations.branch_placeholder[lang]}</p>
                          )}
                          value={selectedBranch}
                          onChange={(e) => {
                            setSelectedBranch(e.value);
                            setBranchError('');
                          }}
                          id="position"
                          options={branches}
                        />
                        {branchError && <p className="authError">{branchError}</p>}
                      </div>
                    </div>

                  </div>
                </form>
              </div>
              <div className="person-info-item">
                <h2 className="person-info-title">{translations.payment_type[lang]}</h2>
                <div className="payment-list">
                  <div
                    role="presentation"
                    className="payment-list-item"
                    onClick={() => handleChange('cash')}
                  >
                    <RadioButton
                      id="cash"
                      inputId="cash"
                      name={translations.cash[lang]}
                      value="cash"
                      onChange={(e) => setPayment(e.value)}
                      checked={payment === 'cash'}
                    />
                    <label htmlFor="cash">{translations.cash[lang]}</label>
                  </div>
                  <div
                    onClick={() => handleChange('vpos')}
                    role="presentation"
                    className="payment-list-item"
                  >
                    <RadioButton
                      inputId="vpos"
                      name="vpos"
                      value="vpos"
                      onChange={(e) => setPayment(e.value)}
                      checked={payment === 'vpos'}
                    />
                    <label htmlFor="vpos">{translations.vPos[lang]}</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="book-aside">
              <div className="book-services">
                <p className="book-aside-title">{translations.service[lang]}</p>
                <div className="book-services-list">
                  {cart.map((e) => (
                    <BasketModalItem
                      isBook
                      key={e.id}
                      title={e.name}
                      price={e.price}
                      handleDeleteFromBasket={handleDeleteFromBasket}
                      id={e.id}
                    />
                  ))}
                </div>
              </div>
              <div className="book-services">
                <div className="book-bonuses-box">
                  <p className="book-aside-title">{translations.promo_code[lang]}</p>
                </div>
                <div className="bonus-form-container">
                  <form
                    onSubmit={handleApplyCode}
                    action="#"
                    className="bonus-form"
                  >
                    <div className="bonus-input-container">
                      <div className="bonus-input-box">
                        <div className="bonus-input-box">
                          <input
                            value={promoCode ?? ''}
                            onChange={(e) => setPromoCode(e.target.value)}
                            type="text"
                            placeholder={translations.promo_placeholder[lang]}
                            className="bonus-form-input"
                          />
                        </div>
                        {isValidCode === 2
                                                    && <p className="authError">{translations.promo_code_error[lang]}</p>}
                      </div>
                      <button type="submit" className="bonus-form-button">
                        {translations.apply_btn[lang]}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div className="book-services">
                <p className="book-aside-title">{translations.order_summary[lang]}</p>
                <div className="order-summary-list">
                  <div className="order-summary">
                    <p className="order-summary-text">{translations.service[lang]}</p>
                    <p className="order-summary-price">
                      {cart.reduce((acc, item) => acc + +item.price, 0)}
                      {' '}
                      {translations.amd[lang]}
                    </p>
                  </div>
                  <div className="order-summary">
                    <p className="order-summary-text">{translations.promo_code[lang]}</p>
                    <p className="order-summary-price">
                      -
                      {isValidCode === 1
                        ? (cart.reduce((acc, item) => acc + Number(item.price), 0) * 0.1).toFixed(0)
                        : 0}
                      {' '}
                      {translations.amd[lang]}
                    </p>
                  </div>
                  <div className="order-summary last">
                    <p className="order-summary-text">{translations.total[lang]}</p>
                    <p className="order-summary-price total">
                      {isValidCode === 1
                        ? (cart.reduce((acc, item) => acc + Number(item.price), 0) * 0.9).toFixed(0)
                        : cart.reduce((acc, item) => acc + Number(item.price), 0)}
                      {' '}
                      {translations.amd[lang]}
                    </p>
                  </div>
                </div>
                <button
                  disabled={loadingBtn}
                  onClick={handleCheckout}
                  type="button"
                  className="book-button"
                >
                  {loadingBtn
                    ? <Spinner isBtn size={20} width={20} height={20} />
                    : translations.checkout[lang]}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : <Spinner width={100} height={100} />}
    </Wrapper>
  );
}

export default CheckOut;
